















import { Ref, Prop, Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'
import { BranchTarget } from '@/api/model/branch-target'

@Component
export default class ListTargetsActions extends Vue {
    @Prop({ required: true }) readonly target!: BranchTarget
    @Ref() wrapper: HTMLDivElement
    visible: boolean = false

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.wrapper, {
            opacity: 0,
        })

        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.wrapper, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }

    onTargetEdit(): void {
        this.$emit('edit', this.target)
    }

    onTargetDelete() {
        this.$emit('delete', this.target)
    }
}
